module.exports = __webpack_public_path__ + "static/media/big_noodle_titling.ff78c5e2.ttf";